module.exports = __webpack_public_path__ + "img/map_Z5.4.B.05.2a633fe4.svg";